import { useMutation } from "@tanstack/react-query";
import { api } from "./api-client";

export type MessagePreview = {
    samples: { groupName: string; rendered: string }[];
    unknownVariables: string[];
    variables: { key: string; label: string; example: string }[];
};

export function useMessagePreview() {
    return useMutation({
        mutationFn: (body: { text: string; accountId: string }) =>
            api.post<MessagePreview>("/api/campaigns/preview-message", body),
    });
}
